import React from 'react';
import { H2, P } from '../components/basic/text'
import axios from 'axios'
import { AppData } from "../data/index"
/* dev url *\
// https://devwww.jostens.com/apps/store/productDetail/1002173/Cave-City-High-School/-/1461929907/CATALOG_REPOSITORY/Cap-and-Gown-Unit/1461929990/

/* output url *\
/productDetail/{customerNumber}/{customerName}/{categoryName}
*/

export const PostBuilderData = (data, dispatch, type) => {
    const urlPaths = window.location.pathname.split("/")
    const customerNumber = urlPaths[4]
    const customerName = urlPaths[5]
    // TODO: This check needs to be removed eventually once api team handles empty category name, until then we are adding jackets for jacket builder.
    let categoryName = ""
    if(type === "jacket") {
        categoryName = "jacket"
    } else {
        categoryName = urlPaths[6]
    }
    //https://devwww.jostens.com/apps/store/productDetail/1002173/Cave-City-High-School/-/   <------should look like this
    const url = `${window.location.origin}/apps/store/productDetail/${customerNumber}/${customerName}/${categoryName}/`
	dispatch({type: 'SET_LOADING', payload: true})
    axios.post(url, 
    data,
    {
        headers: {
            "Content-Type": "application/json"
        }
    })
    .then(data => {
        dispatch({type: 'SET_LOADING', payload: false})
        dispatch({type: 'SET_SUCCESS', payload: true})
        setTimeout(() => {
            dispatch({type: 'SET_SUCCESS', payload: false})
            dispatch({type: 'SET_LOADING', payload: true})
            window.location.href = data.data.redirect
        }, 1000)
    })
    .catch(function (error) {
        alert(error.message)
        dispatch({type: 'SET_LOADING', payload: false})
    })
}

export const PostSaveAndEmailDesign = (data, dispatch) => {
    // const url = "https://devwww.jostens.com/apps/store/saveJacketDesign"
    const url = `${window.location.origin}/apps/store/saveJacketDesign`
	dispatch({type: 'SET_LOADING', payload: true})
    axios.post(url, 
    data,
    {
        headers: {
            "Content-Type": "application/json"
        }
    })
    .then(data => {
        dispatch({type: 'SET_LOADING', payload: false})
        dispatch({type: 'SET_POPUP', payload: null})
        // dispatch({type: 'SET_SUCCESS', payload: true})
        setTimeout(() => {
            // dispatch({type: 'SET_SUCCESS', payload: false})
            dispatch({type: 'SET_POPUP', payload: {
	            title: <H2 align="center" margin="0 0 10px 0">{"Thank You For Saving Your Design"}</H2>,
                info: <P align="center" margin="40px">{"We'll email you a copy of your design so you can click on your email and come back to your saved jacket at any time."}</P>
	        }})
            //window.location.href = data.data.redirect
        }, 1000)
    })
    .catch(function (error) {
        alert(error.message)
        dispatch({type: 'SET_LOADING', payload: false})
    })
}
   
export const GetPaymentPlanDetails = (price, dispatch)=>{
    const productOsr = AppData.productdata?.productOsr
    const urlPaths = window.location.pathname.split("/")
    const customerNumber = urlPaths[4]
    const categoryName = urlPaths[6]
    
    const  url= `${window.location.origin}/apps/store/productPaymentPlanDetails.mvc?productType=JACKET&categoryName=${categoryName}&productOsr=${productOsr}&currentPrice=${price}&currencyCode=USD&customerNumber=${customerNumber}` 
    
    axios.get(url)
    .then(res=>{
        if (res.data.numberOfPayments > 1) {
            dispatch({type:'SET_PAYMENTS', payload:res.data.payments})
            dispatch({type:'SET_NUMBEROFPAYMENTS', payload:res.data.numberOfPayments})
        }
    })
    .catch(e=>{
        console.log(e)
    })
}